<template>
    <div class="create-client">
        <form-component ref="form" class="new-client-page container" v-if="!clientCreated">
            <div class="row">
                <div class="col">
                    <div class="box">
                        <h4>Cliëntgegevens</h4>
                        <p v-if="clientInitialsErrorMessage" class="errorMessage">{{ clientInitialsErrorMessage }}</p>
                        <input-component label="Anonieme cliëntcode" v-model="newClient.initials"></input-component>
                        <input-component type="number" label="Te laat mogen komen tijd in minuten" v-model="newClient.allowedMinutesToLate"></input-component>
                        <p v-if="clientLocationErrorMessage" class="errorMessage">{{ clientLocationErrorMessage }}</p>
                        <label for="location">Woonlocatie</label>
                        <select id="location" class="form-control" v-model="newClient.location">
                            <option v-for="location in getAllLocations" :value="location" :key="location.id">
                                {{ location.locationName }}
                            </option>
                        </select>
                    </div>
                </div>

                <div class="col">
                    <div class="box">
                        <h4>Smartwatch instellingen</h4>
                        <switch-component
                                :checked="newClient.emergencyEnabled"
                                label="Paniek knop"
                                @click.native="onPanicEnabledClicked">
                        </switch-component>
                    </div>
                </div>

                <div class="col">
                    <div class="box">
                        <h4>Contacten</h4>
                        <div class="add-contacts">
                            <div :key="i" v-for="(contact, i) in newClient.contacts">
                                <p class="deleteButton" @click="removeContact(i)">X</p>
                                <p v-if="!contactIsValid(contact)" class="errorMessage">{{ contactIsInvalidErrorMessage }}</p>
                                <input-component required="required" label="Naam" v-model="contact.contactName"></input-component>
                                <input-component required="required" label="Nummer" v-model="contact.phoneNumber"></input-component>
                            </div>
                            <button
                                    ref="addButton"
                                    class="add-button"
                                    @click="addContact"
                            >+</button>
                        </div>
                    </div>
                </div>
            </div>
            <button-component @click.native="saveNewClient">Opslaan</button-component>
        </form-component>

        <div class="client-created" v-if="clientCreated">
            <div class="complete-image"></div>
            <p class="complete-title">Client {{ this.newClient.initials }} aangemaakt, u wordt teruggestuurd naar het overzicht</p>
            <circle-component position="bottom-center" height=236 />
        </div>
    </div>
</template>

<script>
import { RouteName } from '@/utils/enums';
import ButtonComponent from '../../components/button.component.vue';
import FormComponent from '../../components/fields/form.component.vue';
import InputComponent from '../../components/fields/input.component.vue';
import CircleComponent from '../../components/circle.component';
import SwitchComponent from '../../components/fields/switch.component.vue';
import { Client } from '@/domain/client';
import { Location } from '@/domain/location';
import { mapGetters } from 'vuex';
import { lastContactIsValid } from '@/utils/validators';

export default {
    name: 'admin-new-client-page',
    components: {
        FormComponent,
        InputComponent,
        ButtonComponent,
        CircleComponent,
        SwitchComponent
    },
    data() {
        return {
            newClient: Client,
            clientCreated: false,
            clientInitialsErrorMessage: null,
            contactIsInvalidErrorMessage: null,
            clientLocationErrorMessage: null,
            buttonDisabled: false,
            clientLocation: null
        };
    },
    created() {
        this.$store.dispatch('FETCH_ALL_LOCATIONS');
        this.newClient = {
            initials: null,
            connected: false,
            location: Location,
            contacts: [],
            emergencyEnabled: true
        };
      if (this.getAllLocations[0]) {
        // When FETCH_ALL_LOCATIONS is called for a Zorg Professional,
        // it only returns max 1 result. (The location of the Zorg Professional)
        this.newClient.location = this.getAllLocations[0];
      }
    },
    computed: {
        ...mapGetters(['getAllLocations']),
    },
    methods: {
        validateForm: function() {
            !this.newClient.initials ? this.clientInitialsErrorMessage = 'Cliëntcode is verplicht' : this.clientInitialsErrorMessage = null;
            !this.newClient.location ? this.clientLocationErrorMessage = 'Woonlocatie is verplicht' : this.clientLocationErrorMessage = null;
            !lastContactIsValid(this.newClient.contacts) ? this.contactIsInvalidErrorMessage = 'Contact is niet juist ingevoerd' : this.contactIsInvalidErrorMessage = null;
            return !this.clientInitialsErrorMessage && !this.contactIsInvalidErrorMessage && !this.clientLocationErrorMessage;
        },
        addContact: function() {
            if (lastContactIsValid(this.newClient.contacts)) {
                this.newClient.contacts.push({
                    contactName: '',
                    phoneNumber: ''
                });
            }
            // Scroll a bit down so the user can add multiple contacts quickly
            this.$refs.addButton.scrollIntoView();
        },
        contactIsValid: function(contact) {
            return contact.contactName.length > 0 && contact.phoneNumber.length >= 3;
        },
        removeContact(index) {
            this.newClient.contacts.splice(index, 1);
        },
        saveNewClient() {
            if (this.validateForm() && !this.buttonDisabled) {
                this.buttonDisabled = true; // disable after first click, to prevent multiple clients are saved
                this.$store.dispatch('SAVE_NEW_CLIENT', this.newClient)
                    .then(response => {
                        if (response.status === 201) { // created, show confirmation
                            this.clientCreated = true; // redirect back after 2 seconds
                            setTimeout(() => {
                                this.$router.push({name: RouteName.ADMIN_CLIENTS});
                            }, 2500);
                        }
                    })
                    .catch(error => {
                      this.buttonDisabled = false;
                      console.error(error);
                    })
            } else {
                console.error('Niet alle velen zijn juist ingevoerd');
            }
        },
        onPanicEnabledClicked: function() {
            this.newClient.emergencyEnabled = !this.newClient.emergencyEnabled;
        }
    }
};
</script>

<style scoped lang="scss">
    @import '~@radial-color-picker/vue-color-picker/dist/vue-color-picker.min.css';
    .row {
        flex-direction: column;

        @include desktop {
            flex-direction: row;
        }
    }

    .box {
        margin-bottom: 2rem;

        @include desktop {
            background-color: $white;
            // height: 100%;
            padding: 1rem;
            box-shadow: 0 -2px 8px 0px rgba(0, 0, 0, 0.1);
            border-radius: 0.25rem;
        }

        h4 {
            font-weight: 400;
            margin-bottom: 1rem;
            color: $gray-darkest;
        }

        .deleteButton {
            color: red;
            font-weight: bold;
            margin-bottom: 0px;

            &:hover {
                cursor: pointer;
            }
        }

        .errorMessage {
            color: $error;
            font-size: 12px;
            font-weight: normal;
            margin-bottom: 0;
        }
    }

    .add-contacts {
        border-radius: 4px;
        border: 1px solid $gray;
        padding: 1rem;
        position: relative;
        margin-bottom: 1rem;

        .add-button {
            $button-size: 42px;
            position: absolute;
            bottom: -($button-size / 2);
            left: 50%;
            margin-left: -($button-size / 2);
            width: $button-size;
            height: $button-size;
            border-radius: 50%;
            background-color: $primary;
            color: $white;
            font-weight: bold;

            &:hover {
                background-color: $lightGreen;
            }
        }
    }

    .subtitle {
        margin: 1rem 0;
        display: block;
        font-weight: 500;
    }

    .seperator {
        margin: 2rem 0;
        background-color: $gray;
    }

    .input-component,
    .switch-component {
        margin-bottom: 1rem;
    }

    .row-wrapper {
        display: flex;

        .input-component {
            flex-grow: 1;

            &:first-child {
                margin-right: 60px;
            }
        }
    }

    .smartwatch-bg-color {
        margin-bottom: 1rem;
    }
    .client-created {
        height: 100%;
        background-color: $primary;
        color: $white;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .complete-title {
            margin-bottom: 14px;
        }

        p {
            font-size: 16px;
            text-align: center;
        }
    }

    .complete-image {
        width: 95px;
        height: 120px;
        background-image: url('../../assets/icons/watch-large-complete.svg');
        margin-bottom: 64px;
        margin-top: -60px;
    }

    select {
        width: 100%;
        border: 1px solid $gray;
        border-radius: 3px;
        height: 52px;
        padding: 1rem;

        &:hover {
            cursor: pointer;
        }
    }
</style>
